<template>
  <div class="app-layout">
    <nav class="navbar">
      <div class="navbar-container">
        <div class="navbar-left">
          <div class="logo">
            <i class="el-icon-data-line"></i>
            <span class="logo-text">AI Crypto Quant</span>
          </div>
          <div class="nav-menu desktop-menu">
            <router-link
              v-for="item in navigation"
              :key="item.path"
              :exact="item.path === '/'"
              :to="item.path"
              class="nav-item"
            >
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-right">
          <el-dropdown v-if="userInfo" trigger="click">
            <span class="el-dropdown-link user-dropdown">
              <i class="el-icon-user"></i>
              <span class="username">{{ userInfo && (userInfo.account || userInfo.email || '用户') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openChangeEmail">修改邮箱</el-dropdown-item>
              <el-dropdown-item @click.native="openChangePwd">修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="handleLogout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            circle
            class="mobile-menu-btn"
            icon="el-icon-menu"
            @click="mobileMenuOpen = !mobileMenuOpen"
          />
        </div>
      </div>
    </nav>

    <!-- 移动端菜单 -->
    <div v-if="mobileMenuOpen" class="mobile-menu">
      <router-link
        v-for="item in navigation"
        :key="item.path"
        :exact="item.path === '/'"
        :to="item.path"
        class="mobile-nav-item"
        @click.native="mobileMenuOpen = false"
      >
        <i :class="item.icon"></i>
        <span>{{ item.name }}</span>
      </router-link>
      <div v-if="userInfo" class="mobile-nav-item mobile-logout-btn" @click="handleLogout">
        <i class="el-icon-switch-button"></i>
        <span>退出</span>
      </div>
    </div>

    <main class="main-content">
      <router-view></router-view>
    </main>
    <change-email ref="changeEmail" />
    <change-pwd ref="changePwd" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ChangeEmail from '@/components/ChangeEmail/index.vue'
import ChangePwd from '@/components/ChangePwd/index.vue'

export default {
  name: 'AppLayout',
  components: { ChangeEmail, ChangePwd },
  data() {
    return {
      mobileMenuOpen: false,
      navigation: [
        { name: 'AI 交易机器人', path: '/TradingBots', icon: 'el-icon-data-line' },
        { name: '交易所管理', path: '/Exchanges', icon: 'el-icon-s-check' },
        { name: 'AI 引擎', path: '/AIEngines', icon: 'el-icon-cpu' },
        { name: '交易信号管理', path: '/Signals', icon: 'el-icon-bell' },
        { name: '通知管理', path: '/Notifications', icon: 'el-icon-message' },
        // { name: '账单', path: '/Billing', icon: 'el-icon-wallet' }
      ]
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    handleLogout() {
      this.$store.dispatch('user/logout')
    },
    openChangeEmail() {
      if (this.$refs.changeEmail && this.$refs.changeEmail.open) {
        this.$refs.changeEmail.open()
      }
    },
    openChangePwd() {
      if (this.$refs.changePwd && this.$refs.changePwd.open) {
        this.$refs.changePwd.open()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.app-layout {
  min-height: 100vh;
  background-color: $background-dark;
}

.navbar {
  position: sticky;
  top: 0;
  z-index: 50;
  background-color: rgba($card-background, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid $border-color;

  .navbar-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 $spacing-md;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .navbar-left {
      display: flex;
      align-items: center;
      gap: $spacing-xl;

      .logo {
        display: flex;
        align-items: center;
        gap: $spacing-sm;

        i {
          font-size: 24px;
          color: $primary-color;
        }

        .logo-text {
          font-size: 18px;
          font-weight: bold;
          color: $text-primary;
        }
      }

      .nav-menu {
        display: flex;
        gap: $spacing-xs;

        .nav-item {
          display: flex;
          align-items: center;
          gap: $spacing-sm;
          padding: $spacing-sm $spacing-md;
          border-radius: $border-radius-sm;
          color: $text-secondary;
          text-decoration: none;
          transition: all 0.2s;

          i {
            font-size: 16px;
          }

          &:hover {
            background-color: $background-darker;
            color: $text-primary;
          }

          &.router-link-exact-active,
          &.router-link-active {
            background-color: rgba($primary-color, 0.1);
            color: $primary-color;
          }
        }
      }
    }

    .navbar-right {
      display: flex;
      align-items: center;
      gap: $spacing-md;

      .user-dropdown {
        display: inline-flex;
        align-items: center;
        gap: $spacing-sm;
        color: $text-secondary;
        cursor: pointer;
        .username { font-weight: 500; }
        padding: 10px;
        border-radius: 8px;
        background: #000000;
        font-size: 16px;
        .el-icon-user{
          font-size: 18px;
        }
      }

      .mobile-menu-btn {
        display: none;
      }
    }
  }
}

.mobile-menu {
  background-color: $card-background;
  border-bottom: 1px solid $border-color;
  padding: $spacing-md;

  .mobile-nav-item {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    padding: $spacing-md;
    border-radius: $border-radius-sm;
    color: $text-secondary;
    text-decoration: none;
    transition: all 0.2s;
    margin-bottom: $spacing-sm;
    cursor: pointer;

    i {
      font-size: 18px;
    }

    &:hover,
    &.router-link-exact-active,
    &.router-link-active {
      background-color: rgba($primary-color, 0.1);
      color: $primary-color;
    }

    &.mobile-logout-btn {
      margin-top: $spacing-sm;
      border-top: 1px solid $border-color;
      padding-top: $spacing-md;
    }
  }
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: $spacing-lg;
}

// 响应式
@media (max-width: 768px) {
  .navbar .navbar-container {
    .navbar-left .desktop-menu {
      display: none;
    }

    .navbar-right {
      .user-dropdown { display: none; }

      .mobile-menu-btn {
        display: inline-flex;
      }
    }
  }

  .main-content {
    padding: $spacing-md;
  }
}
</style>

